module.exports = __webpack_public_path__ + "img/printer-slash.0818acc8.svg";